export default {
    methods: {
        money(val) {
            return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2
            }).format(val);
        },
        unmask(val) {
            return val.replace(/\D/g, "");
        }
    }
};